export default __webpack_public_path__ + "static/media/burger-rectangle.2d0318f0.svg";